import { Fragment, Suspense } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuFilterLocation } from './SbSharedRefineMenuFilterLocation';
import { SbSharedRefineMenuShippingFiltersWrapperLazy } from '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapperLazy';

export const SbSharedRefineMenuFilterDeliveryOptionsComponent = props => {
    const { isClient, currency, viewer, itemSearch, submitOnBlur, refreshOnSumbit } = props;
    const { isDeliveryOptionsDisabled } = viewer;
    const { appliedFilters = [] } = itemSearch;

    return (
        <Fragment>
            {/* Shipping filters */}
            {!isDeliveryOptionsDisabled && isClient && (
                <Suspense fallback="">
                    <SbSharedRefineMenuShippingFiltersWrapperLazy
                        currency={currency}
                        submitOnBlur={submitOnBlur}
                        appliedFilterNames={new Set(appliedFilters.map(f => f.name))}
                        refreshOnSumbit={refreshOnSumbit}
                    />
                </Suspense>
            )}
            {/* Item Ships From */}
            <SbSharedRefineMenuFilterLocation {...props} />
        </Fragment>
    );
};

SbSharedRefineMenuFilterDeliveryOptionsComponent.propTypes = {
    isClient: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    submitOnBlur: PropTypes.bool,
    refreshOnSumbit: PropTypes.bool,
};

export const SbSharedRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbSharedRefineMenuFilterDeliveryOptionsComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterDeliveryOptions_viewer on Viewer {
                isDeliveryOptionsDisabled: isEnabledByLocale(
                    featureName: "DISABLE_SB_DELIVERY_OPTION_FILTERS"
                )
                ...SbSharedRefineMenuFilterLocation_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuFilterLocation_itemSearch
                appliedFilters {
                    name
                }
            }
        `,
    }
);
